/**
 * Swedish
 */

export default {
  LOCALE: {
    ISO: {
      "639-1"  : "sv",
      "3166-1" : "SE",
      "IETF"   : "sv-SE",
    },
    DIR               : "ltr",
    CURRENCY          : "SEK",
    FALLBACK_CURRENCY : "kr",
    COUNTRY_ID        : "SE",
    TYPEKIT_ID        : "hly5twy",
  },
  META: {
    TITLE       : "Benify Bioförmån – köp digitala biobiljetter och betala med nettolönevdrag",
    NAME        : "Benify Bioförmån – ",
    DESCRIPTION : "Här kan du som ansluten medarbetare köpa digitala biobiljetter och betala med ett nettolöneavdrag.",
  },
  URL: {
    CHECKOUT : "/checkout",
    SUCCESS  : "/checkout/success",
    LOGIN    : "/login",
    LOGOUT   : "/logout",
    SERVICE  : "/faq",
  },
  PROCUREMENT : {
    TITLE : "Välkommen!",
  },
  LOGIN : {
    HEADING : "Logga in",
    TITLE   : "Logga in",
  },
  PRODUCT : {
    PRICE        : "%price/st",
    PCS          : "st",
    DROPDOWN_PCS : "%value st",
    MAX_QTY      : "Maximalt antal av denna produkt uppnått för nuvarande tidsperiod"
  },
  404: {
    TITLE      : "Sidan kunde inte hittas",
    HEADING    : "404",
    SUBHEADING : "Sidan du letar efter verkar inte finnas. <br />Kanske har den en gång funnits och är nu bara ett svagt minne.",
    TO_START   : "Gå till startsidan"
  },
  SERVER_ERROR : {
    TITLE      : "Ett okänt fel har inträffat",
    HEADING    : "500",
    SUBHEADING : "Ett okänt fel har inträffat. Vänligen försök igen senare.",
  },
  VALIDATION : {
    REQUIRED : "Detta fält är obligatoriskt.",
    EMAIL    : "Formatera som en giltig mailadress.",
    PHONE    : "Formatera som ett giltigt telefonnummer.",
  },
  CHECKOUT : {
    ACCEPT     : "Jag godkänner härmed <a target=\"_blank\" href=\"/villkor\">försäljningsvillkoren</a>, samt att <b>%price</b> dras från min nästkommande lön.",
    AMOUNT     : "Antal",
    ARTICLE    : "Artikel",
    HEADING    : "Översikt",
    INFO       : "Har du frågor om förmånen eller om en beställning? <a href=\"/kontakt\">Kontakta vår support</a>",
    PRICE      : "Pris",
    SUBMIT     : "Beställ",
    SUBMITTING : "Skapar order…",
    TOTAL      : "Totalt",
  },
  CODES : {
    YOUR_CODE  : "Värdekod",
    LOADING    : "Reserverar värdekod…",
    FAILURE    : "Vi kan inte reservera några av dina värdekoder just nu. När värdekoderna är reserverade kommer vi att skicka dem till %email.",
    NO_CODE    : "Ej reserverad.",
    VALID_TO   : "Giltig t.o.m. %date",
    COPY : {
      TITLE   : "Kopiera värdekod till urklippet",
      SUCCESS : "Kopierad",
      FAILURE : "Värdekoden kunde inte kopieras.",
    }
  },
  FORM : {
    EDIT_EMAIL : "Ändra mail",
    SUBMIT     : "Spara ändringar",
    SAVING     : "Sparar…",
  },
  SUCCESS : {
    HEADING  : "Beställning registrerad",
    ORDER_ID : "Ditt ordernummer är %id",
    TITLE    : "Beställning registrerad",
    QTY      : "%qty st",
    CLOSE    : "Stäng",
    QUESTIONS : {
      HEADING : "Har du en fråga om din beställning?",
      TEXT    : "Läs igenom svaren på de vanligaste frågorna eller kontakta vår support.",
      LABEL   : "Till FAQ-sidan",
    },
  },
  STATUS_CODE: {
    /* client */
    UNKNOWN       : "Ett okänt fel har uppstått. Vänligen ladda om sidan och försök igen.",
    INVALID_CODE  : "Felaktig rabattkod.",
    NETWORK_ERROR : "Anropet avbröts. Vänligen verifiera att du har en aktiv internetanslutning eller försök igen om en stund.",

    14001: "Önskad beställning överskrider den månatligen tillåtna kvantiteten. Vi har justerat din valda kvantitet till det antal du har kvar.",

    401: "Angiven e‑postadress är ogiltig.",

    /* product */
    1000: "Produkten kunde inte hittas.",
    1001: "Något gick fel. Vänligen kontakta kundservice. (Fel: 1001)",

    /* cart */
    2000: "Produkten finns inte i lager.",
    2001: "Önskat antal är inte tillgängligt.",
    2002: "Produkten saknar attributval.",
    2003: "Produkten kunde inte läggas till i kundvagnen.",
    2004: "Vänligen ange produkt och antal.",
    2005: "Vänligen ange produkt.",
    2006: "Produkten kunde inte hittas.",
    2007: "Produkten finns inte längre i kundvagnen.",
    2008: "Produkten kunde inte läggas till i kundvagnen.",
    2009: "Produkten finns inte längre i kundvagnen.",
    2010: "Högsta tillåtna antal för begärd produkt är överskridet.",
    2011: "Något gick fel. Vänligen kontakta kundservice. (Fel: 2011)",
    2013: "Vissa obligatoriska alternativ saknar val.",

    /* customer */
    3000: "Du är ej inloggad.",
    3001: "Kontoregistrering är för närvarande inaktiverat.",
    3002: "Vänligen ange e‑postadress.",
    3003: "Ett fel har uppstått. Vänligen kontakta kundservice. (Fel: 3003)",
    3004: "Dina uppgifter kunde ej valideras.",
    3005: "Det finns redan ett konto registrerat på den angivna e‑postadressen.",
    3006: "Felaktig e‑postadress eller lösenord.",
    3007: "Dina adressuppgifter kunde ej valideras.",
    3008: "Ett fel har uppstått. Vänligen kontakta kundservice. (Fel: 3008)",
    3009: "Det finns redan ett konto registrerat på den angivna e‑postadressen.",
    3010: "Vänligen ange e‑postadress.",
    3011: "Inget konto kunde hittas på den angivna e‑postadressen",
    3012: "Vänligen ange e‑postadress.",
    3013: "Detta kontot är inte verifierat.",
    3014: "Ett fel har uppstått. Vänligen kontakta kundservice. (Fel: 3014)",
    3015: "Ett fel har uppstått. Vänligen kontakta kundservice. (Fel: 3015)",
    3016: "Kontot kunde inte hittas.",
    3017: "Detta konto är redan aktiverat.",
    3018: "Felaktig verifieringsnyckel.",
    3019: "Vänligen ange e‑postadress.",
    3022: "E‑postadress är obligatoriskt",
    3023: "Angiven e‑postadress är felaktigt formaterad",
    3031: "Nödvändig information saknas. Vänligen se till att du kopierat länken från mailet i sin helhet och verifiera att länken inte utgått.",

    /* checkout */
    4000: "Felaktigt betalsätt.",
    4001: "Felaktigt betalsätt.",
    4002: "Felaktigt leveranssätt.",
    4003: "Felaktigt leveranssätt.",
    4004: "Kundvagnen kunde inte hittas.",
    4005: "Adressuppgifterna innehåller ett fel.",
    4006: "Adressuppgifterna kunde inte verifieras.",
    4007: "Ett okänt fel uppstod.",
    4008: "Din kundvagn är tom.",
    4009: "Leveransadressen kunde inte verifieras.",
    4010: "Vänligen välj leveranssätt.",
    4011: "Faktureringsadressen kunde inte verifieras.",
    4012: "Vänligen välj betalsätt.",
    4013: "Vi har för närvarande problem med den valda betalmetoden. Vänligen försök med en annan.",
    4014: "Betalningsuppgifterna kunde inte verifieras.",
    4015: "Ett okänt fel uppstod.",
    4016: "Det valda betalsättet är inte tillgängligt.",
    4017: "Obligatoriska villkor är inte godkända.",
    4018: "Ett fel har uppstått. Vänligen kontakta kundservice.",
  }
};
